
<button type="button" class="btn border d-flex" (click)="openLanguageModal(languageModal)">
    <span class="mx-1 hover-color d-flex"><i class="fi fi-rr-language mx-1"></i> ვებგევრდის ენა</span>
</button>
<ng-template #languageModal>
    <div class="modal-header">
        <div class="form-floating w-100" *ngIf="!load">
            <select class="form-select" id="lang" [(ngModel)]="defaultLanguage">
                <option *ngFor="let item of selectedLanguages" [value]="item.code">{{ item.name }}</option>
            </select>
   
            <label for="defaultLanguage">{{ 'LANGUAGE.DEFAULT_LANGUAGE' | translate }}</label>
        </div>
    </div>
    <div class="modal-body">

        <app-spinner *ngIf="load" [loading]="load" [text]="'LOAGING' | translate"></app-spinner>
        <app-error *ngIf="error" [title]="''"></app-error>

        <div class="row" >
            <div class="col-md-12 mb-3" *ngFor="let item of data">
                <div class="form-check p-0">
                    <input
                        type="checkbox"
                        class="d-none"
                        autocomplete="off"
                        id="{{item?.name}}">
                    <label
                        class="btn btn-portal border position-relative d-flex p-2 align-items-center"
                        for="{{item?.name}}"
                        [ngClass]="{'form-check-label-active' : item?.action}"
                        (click)="toggleAction(item, $event)">
                        <img src="{{item.img}}" class="w-20 mx-2">
                        {{ item?.name }}
                        <i *ngIf="item?.action" class="fi fi-br-check check text-success"></i>
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="save()">
            <span *ngIf="loadBtn" class="spinner-border spinner-border-sm" role="status" ></span>
            <span *ngIf="!fromSetup">{{ 'SAVE' | translate }}</span>
            <span *ngIf="fromSetup">{{ 'NEXT' | translate }}</span>
        </button>
    </div>
</ng-template>

      
     